export {};

NLMK.initPopupGallery = function() {
	$('.popup-gallery').magnificPopup({
		delegate: 'a',
		type: 'image',
		tLoading: 'Loading image #%curr%...',
		mainClass: 'mfp-mass-media',
		closeMarkup: '<button title="%title%" class="mfp-close"><svg width="19" height="19" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg"><path fill="white" d="M8.414 7l5.293 5.293a1 1 0 0 1-1.414 1.414L7 8.414l-5.293 5.293a1 1 0 1 1-1.414-1.414L5.586 7 .293 1.707A1 1 0 0 1 1.707.293L7 5.586 12.293.293a1 1 0 0 1 1.414 1.414L8.414 7z"/></svg></button>',
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			tCounter: '<span>%curr% / %total%</span>', // markup of counter
			arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"viewBox="0 0 60 16.9"><polygon points="60,7.6 3.3,7.6 9.8,1.2 8.6,0 0,8.5 8.4,16.9 9.6,15.7 3.1,9.3 60,9.3 "/></svg></button>', // markup of an arrow button
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		},
		image: {
			tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
			titleSrc: function(item) {
				return item.el.attr('title') + '<small>by Marsel Van Oosten</small>';
			}
        },
        callbacks: {
            open: () => {
                $('html').addClass('no-scroll no-scroll-ios');
                $('body').addClass('no-scroll no-scroll-ios');
            },

            close: () => {
                $('html').removeClass('no-scroll no-scroll-ios');
                $('body').removeClass('no-scroll no-scroll-ios');
            }
        }
    });
}

$(document).ready(function() {
	NLMK.initPopupGallery();
});
// const $popup = $(document).find('.js-popup');
// const $openImg = $(document).find('.js-card-item');
// const $btnClose = $popup.find('.js-btn-close-popup');

// const $slider = $popup.find('.js-popup-slider');
// const $slides = $popup.find('.js-popup-slide');
// const $btnLeft = $popup.find('.js-popup-left');
// const $btnRight = $popup.find('.js-popup-right');

// let currentIndex = 0;

// $('body').on('click', '.js-card-item', e => {
//     e.preventDefault();

//     $popup.addClass('is-open');
// });

// $btnClose.on('click', () => {
//     $popup.removeClass('is-open')
// })

// $btnLeft.on('click', e => {
//     e.preventDefault();
//     console.log($slides.eq(currentIndex).position().left)

//     currentIndex--;

//     if (currentIndex < 0) {
//         currentIndex = 0;
//     }

//     const posLeft = $slider.position().left;
//     const newX = $slides.eq(currentIndex).position().left;

//     $slider.scrollLeft(newX - posLeft);

//     console.log('qweqweqw')

// });

// $btnRight.on('click', e => {
//     e.preventDefault();

//     console.log($slides.eq(currentIndex).position().left);
//     currentIndex++;

//         if (currentIndex > $slides.length - 1) {
//             currentIndex = $slides.length - 1;
//         }

//         const newX = $slides.eq(currentIndex).position().left;

//         $slider.scrollLeft(newX)
// });



// WEBPACK FOOTER //
// ./js/main/module/popup.js